var DocumentByUrl = /** @class */ (function () {
    function DocumentByUrl() {
        this.timeoutId = null;
        this.documentPage = document.querySelector('.documents-page');
        this.pageOverlay = document.querySelector('.page-overlay');
        this.scrollToDocument();
    }
    DocumentByUrl.prototype.checkAndResetTimeout = function () {
        var _this = this;
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = window.setTimeout(function () {
            _this.scrollToDocument();
        }, 200);
    };
    DocumentByUrl.prototype.scrollToDocument = function () {
        var _a;
        if (this.pageOverlay && this.pageOverlay.classList.contains('visible')) {
            this.checkAndResetTimeout();
            return;
        }
        var docId = this.getDocIdFromUrl();
        var docItem = (_a = this.documentPage) === null || _a === void 0 ? void 0 : _a.querySelector(".document-item[data-document=\"".concat(docId, "\"]"));
        if (docItem) {
            var elementTop = docItem.getBoundingClientRect().top + window.scrollY;
            var offsetPosition = elementTop - 220;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
            docItem.classList.add('active');
        }
    };
    DocumentByUrl.prototype.getDocIdFromUrl = function () {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('doc');
    };
    return DocumentByUrl;
}());
export default DocumentByUrl;
